import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales Leader – the most important role in every business." />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/&amp;title=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;summary=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-mountain.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales Leader – the most important role in every business.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>13 December 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Is you sales leader the most important, or the most dangerous person in your business?.</h3>

<div className="rich-text"><p>The role of the sales leader has always been an important one, but now it’s a role that can either make or break a business. In the global, digital, connected economy, the sales leader, and the go-to-market plan that he/she executes, is now so critical that failure to appoint the right person is this role can be catastrophic. Please allow me to explain why:</p><ol><li><strong>Strategy Execution</strong> - in the absence of a separate 'sales enablement' function, the role of executing the business strategy falls largely in the domain for the sales leader. Senior management nearly always craft sensible and pragmatic business strategy, but we all know that a good strategy means nothing if you don't have the right people to execute. The sales leader is key to execution - always has been.</li><li><strong>Product-Market Fit – </strong>and the conduit between both. It doesn’t matter if you’re selling a product or a service, you need to understand and research how much demand is in the market, and how, when and where that demand is evolving. Today, an effective sales leaders will always have one eye the market -  collecting, synthesizing and disseminating the critical market intelligence that will shape innovation, and constantly iterate the go-to-market strategies required for survival.</li><li><strong>Forecasting </strong>- all business planning begins and ends with the <strong>sales forecast</strong>. This has always been the case, and always will be the case. Unless your sales leader can predict with some degree of accuracy how many units will be sold in a given period, and at what price point, it’s virtually impossible to run a business with any level of predictability. Forecast accuracy is more important now than ever in these VUCA times.</li><li><strong>Cash flow</strong> - is the life-blood of every business, and cash-flow management is more and more critical to business sustainability as the velocity of business increases, disruptive innovation pervades, product life-cycles decrease, and competition intensifies – globally. When sales leaders get the revenue forecast wrong it creates major business risk.</li><li><strong>Cost of Acquisition</strong> - is the last bastion of competitive advantage – that is, if you can’t win new business in a cost effective manner then you are simply eroding margins, profits and ultimately shareholder value. Businesses that carry an inefficient high cost structure end up with a high <em>COGS </em>(cost of goods sold), and this normally means the difference between being profitable or being forced out of business by the inevitable low cost competitors that have found a more cost effective way to serve and acquire your customers.</li></ol><p>So having stated the bleeding obvious in the four points above – now imagine a world where your sales leader is currently <em>asleep at the wheel…….</em></p></div>
<img alt="Asleep at the wheel" className="img-responsive" height="363" src="../../../media/images/AAEAAQAAAAAAAAliAAAAJDU4MDA2Y2ZjLWI0NTUtNDFhZC.width-647.jpg" width="647"/>

<div className="rich-text"><p>…..executing the same tired old sales strategies and go-to-market approach that your business was executing 5, or even 3 years ago. If this is the case, then not only is your business no longer cost effective, but you are also misaligned with the new era of educated and self-directed customers whom now prefer to self-serve. Remembering that your customers are also attempting, wherever possible, to ‘do more with less’ – and this means reducing their own cost of acquisition by avoiding the need to engage with 100’s – 1000’s of vendor sales people, many of whom are deemed to be “no longer adding value to the buying process”.</p><p>Well intentioned and hardworking though he/she may be, your sales leader has the future of your business fairly and squarely in their hands - now more than ever before. One misstep in today’s high velocity VUCA business world can mean disaster, and if said sales leader is a 'change resistor', or if you suspect that he/she is now performing some all too common “ass covering” that nearly always accompanies declining team performance, then beware that it could take 6 or even 12 months for your senior management to uncover the potentially diabolical situation that you are now in – and by then it may be too late to take corrective action. In simple terms, if your sales leader is either unwilling or unable to acknowledge and embrace change then this scenario must be raised up your risk register.</p><p>Putting aside the obvious competitive threats, market share loss, opportunity costs and declining revenues, an outdated sales leader will also destroy culture, which quickly leads to reputational damage (ie. you wont be listed on the 'great places to work' sites) and sales staff attrition.</p><p>So, whilst the role of sales leader carries with it an increasing burden of responsibility and accountability it does also offer great rewards (both quantitative and qualitative) for those that keep pace with the enormous changes that we are now witnessing. However, get it wrong, and the sales leader becomes a <strong>high-risk</strong> to your business sustainability.</p><p>As someone who has worked in technology sales roles for almost 3 decades, I have been lucky enough to have a ring side seat at the evolving game of sales. Throughout my career, I have been lucky enough to work with some outstanding leaders, and have also seen my fair share of hopelessly inadequate sales leaders. The great sales leaders always inspire the way, and authentically model the types of behaviors that will create 'willing followers'. When you find a great sales leader....one that is constantly pushing the envelope to innovate and evolve, then be sure to never let that person leave your business.</p><p>Equally, if you suspect that your sales leader is running his/her department with the old: "<em>this is the way we have always done things”,</em> then start looking for a replacement - PRONTO. That person is now placing your business is grave danger.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/&amp;title=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;summary=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20Leader%20%E2%80%93%20the%20most%20important%20role%20in%20every%20business.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-leader-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>
      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 